import lobbyWidgetIcon from './games.webp';
import playWithCoinsWidgetIcon from './betty-coin-angle.webp';
import noFavorites from './broken-heart.webp';

export default {
  lobbyWidgetIcon,
  playWithCoinsWidgetIcon,
  noFavorites,
};
